module.exports = __webpack_public_path__ + "static/media/letter-h.1c4003e8.png";